const safeDivide = (numerator: number, denominator: number): number => {
  return denominator ? numerator / denominator : 0
}

export default safeDivide
